export default __webpack_public_path__ + "static/media/userAdd.95ad9107.svg";